import React, { useState } from 'react'
import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"

const Gallery = ({ gallery }) => {
    const [open, setOpen] = useState(false)
    const [index, setIndex] = useState(0)

    const slides = gallery.map(image => ({ src: image.img }))

    const renderedImages = gallery.map((image, i) => (
        <div
            key={i}
            className="image-link"
            onClick={() => {
                setIndex(i)
                setOpen(true)
            }}
        >
            <img className="image" src={image.img} alt="" />
        </div>
    ))

    return (
        <div className="gallery">
            {renderedImages}
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={slides}
                index={index}
            />
        </div>
    )
}

export default Gallery